/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_02_Detail_Amateur_0_HeadingInputs */

const en_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your swing is the raw material`)
};

const es_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu swing es la materia prima`)
};

const de_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Schwung ist der Rohstoff`)
};

const zh_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的挥杆就是原材料`)
};

const ar_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السوينغ الخاص بك هو المادة الخام`)
};

const fr_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre swing est la matière première`)
};

const vi_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing của bạn là nguyên liệu thô`)
};

const sw_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swing yako ndiyo malighafi`)
};

const th_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สวิงของคุณคือวัตถุดิบ`)
};

const bs_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tvoj swing je sirovina`)
};

const ja_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのスイングこそが素材`)
};

const ko_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여러분의 스윙이 곧 재료입니다`)
};

const pt_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu swing é a matéria-prima`)
};

const it_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo swing è la materia prima`)
};

const sv_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din sving är råmaterialet`)
};

const nl_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je swing is het ruwe materiaal`)
};

const da_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit sving er råmaterialet`)
};

const nb_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svingen din er råmaterialet`)
};

const fi_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svingisi on raaka-aine`)
};

const pl_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój swing to materiał wyjściowy`)
};

const ru_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш свинг — это исходный материал`)
};

const tr_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swinginiz ham maddedir`)
};

const hi_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपका स्विंग ही कच्चा माल है`)
};

const id_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayunan Anda adalah bahan bakunya`)
};

const ms_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hayunan anda ialah bahan mentahnya`)
};

const cs_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Váš švih je výchozí materiál`)
};

const el_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Το σβινγκ σας είναι η πρώτη ύλη`)
};

const he_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הסווינג שלכם הוא חומר הגלם`)
};

const af_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jou swaai is die grondstof`)
};

const hu_method_content_step_02_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A swinged a nyersanyag`)
};

/**
* | output |
* | --- |
* | "Your swing is the raw material" |
*
* @param {Method_Content_Step_02_Detail_Amateur_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_02_detail_amateur_0_heading = /** @type {((inputs?: Method_Content_Step_02_Detail_Amateur_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_02_Detail_Amateur_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "de") return de_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "th") return th_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "it") return it_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "da") return da_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "id") return id_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "el") return el_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "he") return he_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "af") return af_method_content_step_02_detail_amateur_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_02_detail_amateur_0_heading(inputs)
	return en_method_content_step_02_detail_amateur_0_heading(inputs)
});